import { render, staticRenderFns } from "./Interregional_analysis_left.vue?vue&type=template&id=40c4f6b2&scoped=true"
import script from "./Interregional_analysis_left.vue?vue&type=script&lang=js"
export * from "./Interregional_analysis_left.vue?vue&type=script&lang=js"
import style0 from "./Interregional_analysis_left.vue?vue&type=style&index=0&id=40c4f6b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c4f6b2",
  null
  
)

export default component.exports